import axios from 'axios';
import { getAcqAuthToken } from './auth';

export const getAccountDetails = async (accountId, apiUrls) => {
  const authToken = await getAcqAuthToken();
  if (authToken.data.access_token) {
    const accessToken = authToken.data.access_token;
    return axios.get(`${apiUrls.account}?hashId=${accountId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
  }
};

export const getUserInfo = async (accessToken) => {
  return axios.get(process.env.REACT_APP_BACKEND_DOMAIN+'/userinfo', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });
};

export const getAuthToken = async (domain) => {
  const url = `https://${domain}/oauth/token`;

  return axios.post(
    url,
    {
      client_id: process.env.REACT_APP_BACKEND_CLIENT_ID,
      client_secret: process.env.REACT_APP_BACKEND_CLIENT_SECRET_ID,
      audience: process.env.REACT_APP_BACKEND_AUDIENCE,
      grant_type: 'client_credentials',
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

export const checkLinkedAccounts = async (domain, email,country = 'gbr') => {
  const authToken = await getAuthToken(domain);
  if (authToken.data.access_token) {
    const accessToken = authToken.data.access_token;

    const baseUrl = process.env.REACT_APP_LINKED_URL;
    const url = `${baseUrl}/v1/${country}/User/LinkAccounts?email=${encodeURIComponent(email)}`;
  
    return axios.put(url, null, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });

  }


};
